export default __webpack_public_path__ + "static/media/client23.4eba8771.png";